__turbopack_context__.v({
  "active": "headerMenu-module-scss-module__KyR0HG__active",
  "chevron": "headerMenu-module-scss-module__KyR0HG__chevron",
  "hovered": "headerMenu-module-scss-module__KyR0HG__hovered",
  "localeLink": "headerMenu-module-scss-module__KyR0HG__localeLink",
  "locales": "headerMenu-module-scss-module__KyR0HG__locales",
  "localesList": "headerMenu-module-scss-module__KyR0HG__localesList",
  "menu": "headerMenu-module-scss-module__KyR0HG__menu",
  "menuItem": "headerMenu-module-scss-module__KyR0HG__menuItem",
  "menuLink": "headerMenu-module-scss-module__KyR0HG__menuLink",
  "navMenu": "headerMenu-module-scss-module__KyR0HG__navMenu",
  "rotated": "headerMenu-module-scss-module__KyR0HG__rotated",
  "submenu": "headerMenu-module-scss-module__KyR0HG__submenu",
  "visible": "headerMenu-module-scss-module__KyR0HG__visible",
  "wishlistPart": "headerMenu-module-scss-module__KyR0HG__wishlistPart",
});
